export function TheDetailerIcon() {
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 48 48"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="24" cy="20" r="10" />
      <circle cx="24" cy="20" r="5" />
      <circle cx="24" cy="20" r="1.5" fill="currentColor" />
      <line x1="24" y1="32" x2="24" y2="42" />
      <line x1="18" y1="38" x2="30" y2="38" />
    </svg>
  );
}
